import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "warning-span flex align-content-center justify-content-center p-3"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("i", {
    class: "pi pi-exclamation-triangle",
    style: { "color": "var(--purple-500)", "font-size": "2rem", "margin-right": "10px" }
}, null, -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("h5", null, "No link selected", -1);
const _hoisted_4 = [
    _hoisted_2,
    _hoisted_3
];
const _hoisted_5 = { class: "card" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("h3", { class: "headline mb-5" }, "Resources", -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "font-bold my-2" }, "Main", -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("span", { class: "font-bold my-2" }, "Other", -1);
import CatalogCardLinksDisplay from "@/components/templates/Catalog/CatalogCardLinksDisplay.vue";
import { LinkType } from "@/entities/card.entity";
import { onMounted, ref, watch } from "vue";
import AppConfigSideBar from "@/components/templates/Layout/AppConfigSideBar.vue";
import OneDeskLinkEdit from "@/components/molecules/OneDeskLinkEdit.vue";
import { getLinksByCriteria, deleteLink } from "@/repositories/links.repository";
import useToastNotify from "@/shared/composables/toastNotifyHelper";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CatalogCardLinksDisplayAndEdit',
    props: {
        entityId: {}
    },
    setup(__props) {
        const props = __props;
        const notify = useToastNotify();
        const mandatoryLinks = ref([]);
        const optionalLinks = ref([]);
        const openAppConfig = ref(false);
        const selectedLink = ref(undefined);
        watch(() => props.entityId, async () => {
            await getEntityLinks();
        });
        onMounted(async () => {
            await getEntityLinks();
        });
        const getEntityLinks = async () => {
            openAppConfig.value = false;
            mandatoryLinks.value = await getLinksByCriteria(LinkType.Required, props.entityId);
            optionalLinks.value = await getLinksByCriteria(LinkType.Optional, props.entityId);
        };
        const addNewLink = (linkType) => {
            selectedLink.value = { id: undefined, label: "", value: "", type: linkType, entityId: props.entityId };
            openAppConfig.value = true;
        };
        const editLink = (idAndLinkType) => {
            if (idAndLinkType.linkType === LinkType.Required)
                selectedLink.value = mapSelectedLink(mandatoryLinks.value.find((link) => link.id === idAndLinkType.id));
            else
                selectedLink.value = mapSelectedLink(optionalLinks.value.find((link) => link.id === idAndLinkType.id));
            openAppConfig.value = true;
        };
        const mapSelectedLink = (link) => {
            return {
                id: link.id,
                label: link.label,
                value: link.value,
                type: link.type,
                entityId: link.entityId
            };
        };
        const deleteSelectedLink = async (id) => {
            await deleteLink(id);
            notify('', 'Link deleted', 'success');
            await getEntityLinks();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(AppConfigSideBar, {
                    simple: "",
                    title: "Manage card links",
                    active: selectedLink.value !== undefined,
                    modelValue: openAppConfig.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((openAppConfig).value = $event))
                }, {
                    default: _withCtx(() => [
                        (openAppConfig.value)
                            ? (_openBlock(), _createBlock(OneDeskLinkEdit, {
                                key: 0,
                                modelValue: selectedLink.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedLink).value = $event)),
                                onLinkUpdated: getEntityLinks
                            }, null, 8, ["modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
                    ]),
                    _: 1
                }, 8, ["active", "modelValue"]),
                _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _hoisted_7,
                    _createVNode(CatalogCardLinksDisplay, {
                        "link-type": _unref(LinkType).Required,
                        links: mandatoryLinks.value,
                        onAddNewLink: _cache[2] || (_cache[2] = ($event) => (addNewLink($event))),
                        onEditLink: _cache[3] || (_cache[3] = ($event) => (editLink($event))),
                        onDeleteLink: _cache[4] || (_cache[4] = ($event) => (deleteSelectedLink($event)))
                    }, null, 8, ["link-type", "links"]),
                    _hoisted_8,
                    _createVNode(CatalogCardLinksDisplay, {
                        "link-type": _unref(LinkType).Optional,
                        links: optionalLinks.value,
                        onAddNewLink: _cache[5] || (_cache[5] = ($event) => (addNewLink($event))),
                        onEditLink: _cache[6] || (_cache[6] = ($event) => (editLink($event))),
                        onDeleteLink: _cache[7] || (_cache[7] = ($event) => (deleteSelectedLink($event)))
                    }, null, 8, ["link-type", "links"])
                ])
            ], 64));
        };
    }
});
